export default {
  contactPointSystem: [
    {
      level: '1',
      code: 'phone',
      label: 'Phone'
    },
    {
      level: '1',
      code: 'fax',
      label: 'Fax'
    },
    {
      level: '1',
      code: 'pager',
      label: 'Pager'
    },
    {
      level: '1',
      code: 'other',
      label: 'Other'
    }
  ],
  contactPointUse: [
    {
      level: '1',
      code: 'home',
      label: 'Home'
    },
    {
      level: '1',
      code: 'work',
      label: 'Work'
    },
    {
      level: '1',
      code: 'temp',
      label: 'Temp'
    },
    {
      level: '1',
      code: 'mobile',
      label: 'Mobile'
    }
  ],
  contactStatus: [
    {
      value: 'R',
      label: 'Working'
    },
    {
      value: 'W',
      label: 'Wrong number'
    },
    {
      value: 'N',
      label: 'Non-Working'
    }
  ]
}
